import { JSX, ParentProps, createMemo, splitProps } from 'solid-js'
import styles from './st-layout-table.module.css'

type HTMLAttributes = Omit<JSX.HTMLAttributes<HTMLDivElement>, 'dir'>;

export class LayoutTableProps { }

export default function LayoutTable(props: ParentProps<LayoutTableProps> & HTMLAttributes) {
    const [local, other] = splitProps(props, ['class'])
    const classes = createMemo(() => {
        const res = [styles.table];
        if (local.class) {
            res.push(local.class);
        }
        return res.join(' ');
    });

    return (
        <div class={classes()} {...other} >
            {props.children}
        </div>
    );
}

type Alignment = 'top' | 'middle' | 'bottom';
type LayoutTableColumProps = {
    align?: Alignment;
    padded?: boolean;
    bordered?: boolean;
    auto?: boolean;
};

type RowAttributes = JSX.HTMLAttributes<HTMLDivElement>;

LayoutTable.Row = function LayoutTableColumn(props: ParentProps<LayoutTableColumProps> & RowAttributes) {
    const [local, other] = splitProps(props, ['class', 'align', 'auto', 'padded', 'bordered'])
    const classes = createMemo(() => {
        const res = [styles.row];
        if (local.class) {
            res.push(local.class);
        }

        if (local.align) {
            res.push(styles[local.align]);
        }

        if (local.padded) {
            res.push(styles.padded);
        }

        if (local.bordered) {
            res.push(styles.bordered);
        }

        return res.join(' ');
    });

    return <div class={classes()} {...other} >
        {props.children}
    </div>
}

LayoutTable.Column = function LayoutTableColumn(props: ParentProps<LayoutTableColumProps> & HTMLAttributes) {
    const [local, other] = splitProps(props, ['class', 'auto', 'padded'])
    const classes = createMemo(() => {
        const res = [styles.column];
        if (local.class) {
            res.push(local.class);
        }

        if (local.auto) {
            res.push(styles.auto);
        }

        if (local.padded) {
            res.push(styles.padded);
        }

        return res.join(' ');
    });

    return <div class={classes()} {...other} >
        {props.children}
    </div>
}

LayoutTable.defaultProps = new LayoutTableProps();